// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductList_wrapper__1J4W8","itemContainer":"ProductList_itemContainer__39zqF"};